import { DisplayMode } from '@flywire/internal-components/model';
import { LocaleCodes } from '@flywire/internal-components/utils/translations/types';

import { ENDPOINTS } from '../../endpoints';

export type RecipientFieldsUrlBuilderParams = {
  recipientId: string;
  displayMode?: DisplayMode;
  locale?: LocaleCodes;
};

export const recipientFieldsUrlBuilder = (params: RecipientFieldsUrlBuilderParams): string => {
  const { recipientId, displayMode = 'container', locale } = params;

  let url = `${ENDPOINTS.recipientFieldsForm}?recipient_id=${encodeURIComponent(recipientId)}&display_mode=${encodeURIComponent(displayMode)}`;

  if (locale) {
    url = `${url}&locale=${locale}`;
  }

  return url;
};
